// Single source of truth for brand colors and other design tokens.
//
// CSS variables in `app/globals.css` are the runtime form. This module is
// the build-time form: anywhere we can't reach `var(--color-…)` (Satori
// OG-image rendering, `global-error.tsx` which loads without our CSS,
// the dynamic `accentColor` prop on third-party components) imports from
// here so the palette stays consistent.
//
// Change a value here AND in globals.css together — they describe the
// same palette in two runtimes.

export const COLORS = {
  // Light surfaces (the "eggshell" family): white paper, white raised cards,
  // and the soft off-white wash behind sections and the email shell.
  paper: "#FFFFFF",
  paperHigh: "#FFFFFF",
  paperDeep: "#F7F7F8",
  ink: "#151515",
  // THE two dark surface grays, from the landing page (owner, 2026-07-03):
  // inkBand (darker) = statement/CTA bands; inkLifted (lighter) = the footer
  // panel and dark cards inside light pages. `ink` itself is a TEXT color -
  // never paint a band with it.
  inkBand: "#1c1b1a",
  inkLifted: "#242424",
  inkMuted: "#4B4B4B",
  inkSoft: "#8A8A8A",
  rule: "#E5E5E5",
  ruleStrong: "#CFCFCF",
  vermilion: "#A41034",
  oxblood: "#7B0C27",
  deviceShell: "#F2F2F2",
  deviceDetail: "#A41034",
  night: "#A41034",
  nightInk: "#FFFFFF",
  appNight: "#A41034",
} as const

export type ColorToken = keyof typeof COLORS

// Convenience aliases for the tokens used most often. Prefer these in
// new code so a future palette swap touches one file.
export const ACCENT = COLORS.vermilion
export const ACCENT_DARK = COLORS.oxblood
export const FG = COLORS.ink
export const BG = COLORS.paper
export const FG_MUTED = COLORS.inkMuted
export const RULE = COLORS.ruleStrong
